/** @format */
import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    detailArticle: {},
  },
  mutations: {
    setDetailArticle(state, payload) {
      state.detailArticle = payload
    },
  },
  actions: {
    fetchArticleList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('/video/list', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteArticle(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('/video/delete', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createVideo(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('/video/add', queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    editVideo(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('/video/edit', queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
